import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacyPolicy',
  templateUrl: './privacyPolicy.component.html',
  styleUrls: ['./privacyPolicy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
